/* eslint-disable */
import axios from '@/services/axios'

export default {
    get() {
        return axios.get(`/ad-accounts/get-by-session`);
    },
    update(data) {
        return axios.post(`/ad-accounts/update`, data);
    },
    list() {
        return axios.get("/ad-accounts/get-by-session-list");
    },
    getOne(data) {
        return axios.post("/ad-accounts/get-one", data);
    },
    create(data) {
        return axios.post(`/ad-accounts/create`, data);
    }
};
